
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bgp-overview/[resource]",
      function () {
        return require("private-next-pages/bgp-overview/[resource].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bgp-overview/[resource]"])
      });
    }
  